import React from 'react'

import { Box, Typography } from '@material-ui/core'

const AudienceTitle = () => {
  return (
    <Box
      pb={4}
      alignItems="center"
    >
      <Typography variant="h6">Audience</Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        Customize who will receive this message
      </Typography>
    </Box>
  )
}

export default AudienceTitle
